import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center space-y-4">
        <XCircle className="w-14 h-14 text-slate-400 mx-auto" />
        <h1 className="text-xl font-bold text-slate-800">Paiement annulé</h1>
        <p className="text-sm text-slate-500">Aucun montant n'a été prélevé. Vous pouvez réessayer à tout moment.</p>
        <button
          onClick={() => navigate(-2)}
          className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 text-sm"
          data-testid="payment-cancel-back-btn"
        >
          Retour
        </button>
      </div>
    </div>
  );
}
